module.exports = __webpack_public_path__ + "img/csv.6b6580f1.png";